import raw from './mediaList.json'

/**
 * 新闻列表（mediaList.json）字段约定：
 *
 * 站内原创：
 *   title / intro / createTime / img / url: "/news_detail/n"
 *
 * 公众号转载（标题、摘要自拟，点击直跳原文）：
 *   title / intro / createTime / img
 *   url: "https://mp.weixin.qq.com/s/xxxx"
 *   source: "wechat"   // 可选；不写时只要 url 为 http(s) 也按外链处理
 *
 * img：
 * - http(s) 外链：原样使用
 * - 以 / 开头：public 静态资源
 * - 其它：相对 src/assets/images/news-list/（如 news5/cover.png）
 */
const newsImages = require.context(
  '@/assets/images/news-list',
  true,
  /\.(png|jpe?g|gif|webp)$/i
)

function resolveImg (img) {
  if (!img) return ''
  if (/^https?:\/\//i.test(img)) return img
  if (img.startsWith('/')) return img

  const key = './' + img.replace(/^\.\//, '')
  if (newsImages.keys().includes(key)) {
    return newsImages(key)
  }

  console.warn('[mediaList] 找不到图片文件:', img, '（请确认 src/assets/images/news-list/ 下是否存在）')
  return ''
}

/** 是否外链新闻（非站内路由） */
export function isExternalNewsUrl (url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim())
}

/** 是否公众号来源（显式 source，或微信域名外链） */
export function isWechatNews (item) {
  if (!item) return false
  if (item.source === 'wechat') return true
  const url = item.url
  return typeof url === 'string' && /mp\.weixin\.qq\.com/i.test(url)
}

/**
 * 打开新闻：站内路由 push，外链新窗口；空 url 不跳转
 * @param {{ url?: string }} itemOrUrl
 * @param {{ push: Function }} router
 */
export function openNewsLink (itemOrUrl, router) {
  const url =
    typeof itemOrUrl === 'string' ? itemOrUrl : (itemOrUrl && itemOrUrl.url)
  if (!url || typeof url !== 'string') return

  const trimmed = url.trim()
  if (!trimmed) return

  if (trimmed.startsWith('/')) {
    if (router && typeof router.push === 'function') {
      router.push(trimmed)
    }
    return
  }

  if (/^https?:\/\//i.test(trimmed)) {
    window.open(trimmed, '_blank', 'noopener,noreferrer')
  }
}

export const mediaList = raw.mediaList.map(item => ({
  ...item,
  img: resolveImg(item.img),
}))
